import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import './index.css';
import { createBrowserRouter } from 'react-router';
import { RouterProvider } from 'react-router/dom';
import { LanguageProvider } from '@mbd/ui-components';
import { PlatformEntryPage } from './pages/PlatformEntryPage';
import { LoginPage } from './pages/LoginPage';
import { sessionMiddleware } from './features/auth';
import { ConfigContextProvider } from './shared/context/ConfigContext';
import i18n, { initI18n } from './i18next';

const router = createBrowserRouter([
  {
    element: <PlatformEntryPage />,
    index: true,
    middleware: [sessionMiddleware],
  },
  { path: 'login', element: <LoginPage /> },
  { path: '*', element: <div>Sorry, the page is not found!</div> },
]);

initI18n.then(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <ConfigContextProvider>
        <LanguageProvider i18n={i18n}>
          <RouterProvider router={router} />
        </LanguageProvider>
      </ConfigContextProvider>
    </StrictMode>,
  );
});
